import {
  useCouponListReady,
  useEffectiveAppliedCoupon,
} from 'src/features/Coupon/Regular/states'
import {
  ExtraPackageBoostType,
  ExtraPackageCampaignCategory,
  useExtraPackages,
} from 'src/features/ExtraPackage'

/**
 * Hook to get the state of the New user discount
 *
 * @returns The end time of the discount if available.
 *          `undefined` otherwise.
 */
export default function useNewUserDiscount() {
  const effectiveCouponCode = useEffectiveAppliedCoupon()
  const couponListReady = useCouponListReady()
  const extraPackages = useExtraPackages({
    currentTier: undefined,
    promotionOption: couponListReady
      ? { extraPackageBoostCode: effectiveCouponCode ?? undefined }
      : null,
  })
  const boosts = extraPackages
    ?.map(pack => pack.extraPackageBoosts)
    .filter(Boolean)

  const endTime = boosts?.find(boost => {
    const targetBoost = boost?.find(
      it =>
        it.category === ExtraPackageCampaignCategory.EventBased &&
        it.type === ExtraPackageBoostType.Campaign &&
        it.name === 'NewUser',
    )
    return targetBoost != null
  })?.[0].endTime

  return endTime || undefined
}
